<template>
  <div class="content-main">
    <!-- <div class="box-title">
      <p>名称</p>
      <p>操作</p>
    </div> -->
    <div v-if="mydata.userFavoritesArr.length === 0">
      <p style="line-height: 300px; text-align: center; letter-spacing: 1px;color:#999999">
        暂无收藏
      </p>
    </div>
    <div class="box-big" v-else>
      <div
        class="box-item"
        v-for="(item, index) in mydata.userFavoritesArr"
        :key="index"
      >
        <p style="cursor: pointer" @click="submitButton(item.id)">
          {{ item.content.title }}
        </p>
        <p @click="cancelCollect(item)" style="cursor: pointer">取消收藏</p>
      </div>
    </div>
    <!--分页 -->
    <div
      class="gl-pagination"
    >
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import dayjs from "dayjs";

//引入我的收藏列表、取消收藏接口
import {
  userFavoritesList,
  delFavoritesList,
} from "@/api/personalCenter/myCollection/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  userFavoritesArr: [], //收藏列表

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  type: "1", //写死-类型就是1
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userFavoritesFn();
}

//获取收藏列表
function userFavoritesFn() {
  userFavoritesList(mydata.userInfo.jwt, {
    type: mydata.type,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    mydata.userFavoritesArr = res.data.list;
    mydata.pageObj.total = res.data.count;
    // console.log(res.data.list, "获取收藏列表");
  });
}

userFavoritesFn();

//取消收藏
function cancelCollect(item) {
  ElMessageBox.confirm("是否取消收藏该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delFavoritesList(mydata.userInfo.jwt, { favorite_id: item.id }).then(
        (res) => {
          ElMessage({
            message: res.msg,
            type: "success",
          });
          // 查询列表
          userFavoritesFn();
        }
      );
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}

//按钮点击事件
function submitButton(id) {
  router.push({
    path: "/layout/list/topicSubjectDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.content-main {
  // width: 916px;
  padding:0px 16px;
  
  // margin-top: 30px;
  // .box-title {
  //   width: 916px;
  //   height: 47px;
  //   padding: 0px 43px 0px 19px;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: #333333;
  //   background-color: #f7f9fa;
  //   //  border:1px solid blue;
  //   > p:nth-of-type(2) {
  //     width: 80px;
  //     // border: 1px solid red;
  //   }
  // }
  //装每条的大盒子
  .box-big {
    // height: 520px;
    // border:1px solid red;
    min-height: 500px;
    // margin-top:10px !important;
    // border: 1px solid red;
    //每一条
    .box-item {
      height: 100px;
      // display: flex;
      
      // justify-content: space-between;
      // align-items: center;
      // padding: 0px 43px 0px 19px;
      // margin-bottom: 20px;
      padding:16px 0px 10px 0px;
      border-bottom: 1px solid #dcdee2;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      > p:nth-of-type(1) {
        // width: 500px;
        // border:1px solid rgb(0, 255, 85);
        line-height: 22px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
      > p:nth-of-type(2) {
        font-size: 14px;
        color:#666666;
        position: absolute;
        bottom:10px;
        right:0px;
        // width: 80px;
      }
    }
    .box-item:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    .box-item:hover {
      p {
        color: #009de0;
      }
    }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
</style>
